export default [
    {
        path: 'lancamento-coleta',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-lancamento-coleta' */
            '@/views/exame-laboratorial/lancamento-coleta/Index'
        ),
        redirect: 'lancamento-coleta/create',
        children: [
            {
                name: 'exame-laboratorial-lancamento-coleta-create',
                path: 'create',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-lancamento-coleta' */
                    '@/views/exame-laboratorial/lancamento-coleta/Form.vue'
                ),
            },
        ],
    }
]